import ProgramsModule from './containers/programsModule'

export {default as ProgramsModuleLayout} from './components/programsModuleLayout'

export default ProgramsModule
